import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Header } from 'components/HeroSemantic';

class ThemeHeader extends Component {
  static propTypes = {
    as: PropTypes.string,
    primary: PropTypes.string.isRequired,
    lineColor: PropTypes.string,
    titleId: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
  };

  static defaultProps = {
    as: 'h2',
    defaultMessage: undefined,
  };

  render() {
    const { as, defaultMessage, lineColor, titleId, primary } = this.props;
    // w-fit makes the wrapper shrink to the text width so the underline tracks the title.
    // max-w-full keeps it from forcing horizontal overflow when the title wraps.
    return (
      <div className="mb-6 mt-2 w-fit max-w-full">
        <Header as={as} className="m-0 leading-tight">
          <FormattedMessage id={titleId} defaultMessage={defaultMessage} />
        </Header>
        <span
          aria-hidden="true"
          className="mt-1.5 block h-[3px] w-full rounded-full"
          style={{ backgroundColor: lineColor || primary }}
        />
      </div>
    );
  }
}

export default connect(state => ({ primary: state.tenant.theme.colors.primary }))(ThemeHeader);
